export const toItems = (items = [], currentItems) => {
  const currentItemsArr = currentItems
    ? fromItems(currentItems, true).sort((a, b) => a.id - b.id)
    : []

  return items
    .sort((a, b) => a.id - b.id)
    .reduce((acc, item, index) => {
      if (acc[item.itemType]) {
        acc[item.itemType]
          .sort((a, b) => a.id - b.id)
          .push({
            ...item,
            ...(currentItems ? { pristine: currentItemsArr[index]?.pristine } : { pristine: true })
          })
      } else {
        acc[item.itemType] = [
          {
            ...item,
            ...(currentItems ? { pristine: currentItemsArr[index]?.pristine } : { pristine: true })
          }
        ]
      }
      return acc
    }, {})
}

export const fromItems = (items, withPristine) => {
  return Object.values(items).reduce((acc, item) => {
    return acc.concat(
      item.map(i => ({
        ...i,
        ...(withPristine ? { pristine: i.pristine } : {})
      }))
    )
  }, [])
}

export const toTemplates = templates =>
  templates.map(template => ({ value: template.id, label: template.name }))
